import React from "react";
import AuthService from '../Helpers/AuthService';
import "./NoviRadnik.css";

export default class noviRadnik extends React.Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.Auth = new AuthService();
        this.state = { username: null, password: null,idradnejedinice: 'odaberi',ime: '',
                       prezime: '',idbroj:'',idufirmi:''};
    }

    componentWillMount() {}

    handleFormSubmit(e) {
         e.preventDefault();   
                let user = this.Auth.getProfile();
                console.log(this.state.idradnejedinice);

                if(this.state.idradnejedinice === 'odaberi'){
                   this.setState({idradnejediniceErr: true}) 
                 }else{
                    this.setState({idradnejediniceErr: false}) 
                 }
                 if(this.state.ime.length < 1){
                    this.setState({imeErr: true})
                 }else{
                    this.setState({imeErr: false}) 
                 }
                  if(this.state.prezime.length < 1){
                    this.setState({prezimeErr: true})
                 }else{
                    this.setState({prezimeErr: false}) 
                 }
                  if(this.state.idbroj.length < 1){
                    this.setState({idbrojErr: true})
                 }else{
                    this.setState({idbrojErr: false}) 
                 }
                  if(this.state.idufirmi.length < 1){
                    this.setState({idufirmiErr: true})
                 }else{
                    this.setState({idufirmiErr: false}) 
                 }

                 if(this.state.ime && this.state.idbroj && this.state.prezime && this.state.idufirmi &&
                    this.state.idradnejedinicec!== 'odaberi'){
               this.props.postNoviRadnik(this.state.ime,this.state.prezime,this.state.idbroj,this.props.idfirme,this.state.idufirmi,this.state.idradnejedinice,user.id);
               }
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {
        var optionNodes = this.props.radneJedinice.map(function(
            radnaJedinica,
            index
        ) {
            return (

                <option key={index} value={radnaJedinica.idRadne_Jedinice}>
                    {radnaJedinica.Naziv}
                </option>
            );
        });

        return (
            <div >
                <div className="center_nr">
                    <div className="card_nr">
                      
                        <form onSubmit={this.handleFormSubmit}>
                            <input
                                className="form-item_nr"
                                placeholder="Ime radnika..."
                                name="ime"
                                type="text"
                                onChange={this.handleChange}
                            />{this.state.imeErr && <label style={{color: 'red',fontSize: 13,paddingTop:'1px'}}>Ovo polje je obavezno</label>}
                            <input
                                className="form-item_nr"
                                placeholder="Prezime radnika..."
                                name="prezime"
                                type="text"
                                onChange={this.handleChange}
                            />
                            {this.state.prezimeErr && <label style={{color: 'red',fontSize: 13,paddingTop:'1px'}}>Ovo polje je obavezno</label>}
                            <input
                                className="form-item_nr"
                                placeholder="ID broj RFID kartice..."
                                name="idbroj"
                                type="text"
                                onChange={this.handleChange}
                            />
                            {this.state.idbrojErr && <label style={{color: 'red',fontSize: 13,paddingTop:'1px'}}>Ovo polje je obavezno</label>}
                            <input
                                className="form-item_nr"
                                placeholder="ID radnika u firmi..."
                                name="idufirmi"
                                type="text"
                                onChange={this.handleChange}
                            />
                            {this.state.idufirmiErr && <label style={{color: 'red',fontSize: 13,paddingTop:'1px'}}>Ovo polje je obavezno</label>}
                            <select value={this.state.idradnejedinice}  
                                    onChange={this.handleChange} 
                                    name = "idradnejedinice" 
                                    className="form-item_select_nr">
                                    <option key={0} value={"odaberi"}> Radna jedinica ... </option>{optionNodes}
                            </select>
                            {this.state.idradnejediniceErr && <label style={{color: 'red',fontSize: 13,paddingTop:'1px'}}>Ovo polje je obavezno</label>}
                            <input
                                className="form-submit_nr"
                                value="Dodaj radnika"
                                type="submit"
                            />
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Moduli/NoviRadnik.js